<template>
  <div v-if="display">
    <modal-layout-top :title="title" hideCloseButton class="with-buttons">
      <modal-layout-buttons :store-name="'workOrders'" />
    </modal-layout-top>
    <div class="content slider-modal">
      <div class="slider-modal-fields">
        <div class="field">
          <label class="label">Status</label>
          <div v-if="workOrder.status === 'Invoiced'">
            <input class="input" type="text" value="Fakturerad" :disabled="disabled">
          </div>
          <div v-else class="select">
            <select v-model="workOrder.status">
              <option value="Quoted">Offererad</option>
              <option value="Planned">Planerad</option>
              <option value="Started">Pågående</option>
              <option value="Registered">Registrerad</option>
              <option value="Cancelled">Makulerad</option>
            </select>
          </div>
        </div>

        <!--
        <div class="field-small" v-if="isUpdate">
          <label class="label">Datum</label>
          <input class="input" type="text" :value="workOrder.statusDate | moment('YYYY-MM-DD HH:mm')" disabled>
        </div>

        <div class="field-small" v-else>
          <label class="label">Datum</label>
          <input class="input" type="text" :value="Date.now() | moment('YYYY-MM-DD HH:mm')" disabled>
        </div>
        -->

        <div class="field">
          <label class="label">Datum</label>
          <input class="input" type="date" v-model="workOrder.verificationDate">
        </div>

        <div class="field">
          <label class="label">Extern not</label>
          <input class="input" type="text" v-model="workOrder.invoiceNote" :disabled="disabled" />
        </div>

        <div class="field">
          <label class="label">Intern not</label>
          <input class="input" type="text" v-model="workOrder.internalNote" :disabled="disabled" />
        </div>

        <div class="field">
          <label class="label">Ägare</label>
          <div class="select">
            <select v-model="workOrder.workOrderOwnerUserId" :disabled="disabled">
              <option :value="null">DELA</option>
              <option v-for="user in users" :value="user.userId" :key="user.userId">{{ user.initials }}</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Stöd</label>
          <div class="select">
            <select v-model="workOrder.workOrderHelperUserId" :disabled="disabled">
              <option :value="null">INGEN</option>
              <option :value="-1">DELA</option>
              <option v-for="user in users" :value="user.userId" :key="user.userId">{{ user.initials }}</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">&nbsp;</label>
          <input id="invoiceable" type="checkbox" v-model="workOrder.invoiceable" class="switch is-rounded" checked="checked" :disabled="disabled">
          <label for="invoiceable" class="label">Debiteras</label>
        </div>

      </div>

      <hr>

      <h4>Taxa</h4>
      <!-- MOBILE -->
      <div class="is-hidden-desktop">
        <div v-for="(item, index) in workOrder.items.filter(x => x.productType === 'Rate')" :key="item.workOrderItemId" class="line-wrapper">

          <h5 style="float:left;">Taxa {{ index + 1 }}</h5>
          <button v-if="!disabled" class="button is-danger is-small" style="float:right" @click="removeWorkOrderLine(item)"><span class="icon"><i class="fal fa-layer-minus"></i></span><span>Ta bort taxa</span></button>
          <div style="clear:both;"></div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Typ</label>
            </div>
            <div class="inline-input">
              <div class="select">
                <select v-model="item.productId" @change="rateLineProductChanged(item)" :disabled="disabled">
                  <!--<option :value="null">Välj taxa...</option>-->
                  <option v-for="price in prices.filter(x => x.productType === 'Rate')" :value="price.productId" :key="price.productId">{{ price.productName }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Est. tid</label>
            </div>
            <div class="button minus-button" @click="reduceHours(item, 'hoursEstimated')">-</div>
            <div class="inline-input">
              <input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.hoursEstimated">
            </div>
            <div class="button plus-button" @click="increaseHours(item, 'hoursEstimated')">+</div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Arb. tid</label>
            </div>
            <div class="button minus-button" @click="reduceHours(item, 'workedHours')">-</div>
            <div class="inline-input">
              <input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.workedHours">
            </div>
            <div class="button plus-button" @click="increaseHours(item, 'workedHours')">+</div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Deb. tid</label>
            </div>
            <div class="button minus-button" @click="reduceHours(item, 'invoiceableHours')">-</div>
            <div class="inline-input">
              <input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.invoiceableHours">
            </div>
            <div class="button plus-button" @click="increaseHours(item, 'invoiceableHours')">+</div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">à-pris</label>
            </div>
            <div class="inline-input">
              <input type="number" style="text-align: right;" class="input" step="0.5" min="0" v-model="item.unitPrice" disabled>
            </div>
          </div>

        </div>
      </div>

      <!-- DESKTOP -->
      <table class="table is-fullwidth is-narrow is-hidden-touch">
        <thead>
          <tr>
            <th style="width:35%">Typ</th>
            <th>Est. tid</th>
            <th>Arb. tid</th>
            <th>Deb. tid</th>
            <th>à-pris</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in workOrder.items.filter(x => x.productType === 'Rate')" :key="item.workOrderItemId">
            <td>
              <div class="select">
                <select v-model="item.productId" @change="rateLineProductChanged(item)" :disabled="disabled">
                  <!--<option :value="null">Välj taxa...</option>-->
                  <option v-for="price in prices.filter(x => x.productType === 'Rate')" :value="price.productId" :key="price.productId">{{ price.productName }}</option>
                </select>
              </div>
            </td>
            <td><input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.hoursEstimated"></td>
            <td><input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.workedHours"></td>
            <td><input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.invoiceableHours"></td>
            <td><input type="number" style="text-align: right;" class="input" step="0.5" min="0" v-model="item.unitPrice" disabled></td>
            <td>
              <button v-if="!disabled" class="button is-danger" style="float:right" @click="removeWorkOrderLine(item)"><span class="icon"><i class="fal fa-layer-minus"></i></span><span>Ta bort taxa</span></button>
            </td>
          </tr>
        </tbody>
      </table>

      <button v-if="!disabled" class="button is-info is-pulled-right" @click="addRateLine()"><span class="icon is-small"><i class="fal fa-layer-plus"></i></span><span>Lägg till taxa</span></button>

      <hr class="separator">

      <h4>Hyra</h4>
      <!-- MOBILE -->
      <div class="is-hidden-desktop">
        <div v-for="(item, index) in workOrder.items.filter(x => x.productType === 'Rent')" :key="item.workOrderItemId" class="line-wrapper">

          <h5 style="float:left;">Hyra {{ index + 1 }}</h5>

          <button v-if="!disabled" class="button is-danger is-small" style="float:right" @click="removeWorkOrderLine(item)"><span class="icon"><i class="fal fa-layer-minus"></i></span><span>Ta bort hyra</span></button>

          <div style="clear:both;"></div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Typ</label>
            </div>
            <div class="inline-input">
              <div class="select">
                <select v-model="item.productId" @change="rateLineProductChanged(item)" :disabled="disabled">
                  <option :value="null">Välj hyra...</option>
                  <option v-for="price in prices.filter(x => x.productType === 'Rent')" :value="price.productId" :key="price.productId">{{ price.productName }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">Antal</label>
            </div>
            <div class="button minus-button" @click="reduceHours(item, 'quantity')">-</div>
            <div class="inline-input">
              <input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.quantity">
            </div>
            <div class="button plus-button" @click="increaseHours(item, 'quantity')">+</div>
          </div>

          <div class="is-flex mobile-box">
            <div class="label-left">
              <label class="label">à-pris</label>
            </div>
            <div class="inline-input">
              <input type="number" style="text-align: right;" class="input" step="0.5" min="0" v-model="item.unitPrice" disabled>
            </div>
          </div>

        </div>
      </div>

      <!-- DESKTOP -->
      <table class="table is-fullwidth is-narrow is-hidden-touch">
        <thead>
          <tr>
            <th>Typ</th>
            <th>Antal</th>
            <th>à-pris</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in workOrder.items.filter(x => x.productType === 'Rent')" :key="item.workOrderItemId">
            <td>
              <div class="select">
                <select v-model="item.productId" @change="rentLineProductChanged(item)" :disabled="disabled">
                  <option :value="null">Välj hyra...</option>
                  <option v-for="price in prices.filter(x => x.productType === 'Rent')" :value="price.productId" :key="price.productId">{{ price.productName }}</option>
                </select>
              </div>
            </td>
            <td><input type="number" style="text-align: center;" class="input" step="0.5" min="0" :disabled="disabled" v-model="item.quantity"></td>
            <td><input type="number" style="text-align: right;" class="input" step="0.5" min="0" v-model="item.unitPrice" disabled></td>
            <td>
              <button v-if="!disabled" class="button is-danger" style="float:right" @click="removeWorkOrderLine(item)"><span class="icon"><i class="fal fa-layer-minus"></i></span><span>Ta bort hyra</span></button>
            </td>
          </tr>
        </tbody>
      </table>

      <button v-if="!disabled" class="button is-info is-pulled-right" @click="addRentLine()"><span class="icon is-small"><i class="fal fa-layer-plus"></i></span><span>Lägg till hyra</span></button>

      <hr class="separator">

      <div class="is-clearfix" />
      <modal-layout-buttons
        :hideSave="disabled"
        :store-name="'workOrders'"
       />

      <template v-if="showDelete && 1 === 0">
        <hr>
        <a class="is-pulled-right" @click="deleteWorkOrder">Radera Insats</a>
      </template>

    </div>

  </div>
</template>

<script>

import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'work-order-modal',
  data () {
    return {
      workOrder: { },
      users: { },
      prices: [],
      isUpdate: false,
      display: false,
      showDelete: false,
      context: null
    }
  },

  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },

  props: {
    projectCode: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: false
    },
    workOrderId: {
      type: Number,
      required: false
    },
    workOrderOwnerUserId: {
      type: Number
    }
  },
  computed: {
    title () {
      if (!this.isUpdate) {
        return this.projectCode + ': Skapa ny insats'
      } else {
        return 'Ändra insats'
      }
    },
    disabled () {
      return this.workOrder.status === 'Invoiced'
    }
  },
  methods: {
    ...mapActions('workOrders', ['getById', 'getEmptyWorkOrder', 'delete']),
    ...mapActions('users', {
      getAllUsers: 'getAll'
    }),
    ...mapActions('priceList', {
      getPrices: 'getByProjectCode'
    }),
    closePanel () {
      this.$emit('closePanel')
    },
    reduceHours (item, property) {
      if (item[property] >= 0.5) {
        item[property] -= 0.5
      }
    },
    increaseHours (item, property) {
      if (!item[property]) {
        item[property] = 0
      }
      item[property] += 0.5
    },
    save () {
      if (this.workOrder.workOrderId) {
        this.$store.dispatch(this.context + '/update', this.workOrder).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.$store.dispatch(this.context + '/create', this.workOrder).then(() => {
          this.closePanel()

          // Reload project list if created from context menu
          if (this.$route.name === 'Projects') {
            this.$store.dispatch('projects/getProjects')
          } else if (this.$route.name === 'Home_ProjectOwner') {
            this.$store.dispatch('projectsOwner/getProjects')
          } else if (this.$route.name === 'Home_ProjectReviewer') {
            this.$store.dispatch('projectsReviewer/getProjects')
          } else if (this.$route.name === 'Invoices') {
            this.$store.dispatch('projectsInvoice/getListData')
          }
        })
      }
    },

    addRateLine () {
      console.log(this.prices)
      // Check if there already are empty lines
      const productId = this.prices.filter(x => x.productType === 'Rate')[0].productId
      const rateLines = this.workOrder.items.filter(x => x.productType === 'Rate')

      if (rateLines && rateLines.length > 0) {
        if (rateLines.find(x => x.productId === productId && !x.hoursEstimated && !x.workedHours && !x.invoiceableHours)) {
          this.$toast('Du har redan en tom rad', 'info')
          return
        }
      }

      let newItem = {
        productId: productId,
        productType: 'Rate',
        hoursEstimated: 0,
        workedHours: 0,
        invoiceableHours: 0
      }

      this.workOrder.items.push(newItem)

      this.rateLineProductChanged(newItem)
    },

    addRentLine () {
      // Check if there already are empty lines
      const rentLines = this.workOrder.items.filter(x => x.productType === 'Rent')

      if (rentLines && rentLines.length > 0) {
        if (rentLines.find(x => x.productId === null)) {
          this.$toast('Du har redan en tom rad', 'info')
          return
        }
      }

      this.workOrder.items.push({
        productId: null,
        productType: 'Rent',
        quantity: 0
      })
    },

    removeWorkOrderLine (workOrderLine) {
      this.workOrder.items = this.workOrder.items.filter(x => x !== workOrderLine)
    },

    rateLineProductChanged (workOrderLine) {
      workOrderLine.unitPrice = this.getProductUnitPrice(workOrderLine)
    },

    rentLineProductChanged (workOrderLine) {
      workOrderLine.unitPrice = this.getProductUnitPrice(workOrderLine)
    },

    getProductUnitPrice (workOrderLine) {
      if (workOrderLine.productId === null) {
        return null
      }

      const priceListItem = this.prices.find(x => x.productId === workOrderLine.productId)
      return priceListItem.unitPrice
    },

    deleteWorkOrder () {
      this.$confirm('Radera Insats', 'Är du säker på att du vill radera Insatsen ' + this.workOrder.workOrderId + '?').then((result) => {
        if (result.value) {
          this.delete(this.workOrderId)
          this.closePanel()
        }
      })
    }
  },

  created () {
    switch (this.$route.name) {
      case 'Project_WorkOrders':
        this.context = 'workOrdersPerProject'
        break
      case 'Home_WorkOrders':
        this.context = 'workOrders'
        break
      case 'Invoices':
      case 'Projects':
      case 'Home_ProjectOwner':
      case 'Home_ProjectReviewer':
        this.context = 'workOrders'
        break
      default:
        console.error('Context not defined for ' + this.$route.name)
    }

    console.log('store context: ' + this.context)

    this.$on('emitSave', () => {
      this.save()
    })

    let workOrderPromise = null

    if (this.workOrderId) {
      this.isUpdate = true

      workOrderPromise = this.getById(this.workOrderId).then((workOrder) => {
        this.workOrder = workOrder
      })

      let role = this.$store.state.auth.user.role
      if (role === 'SuperAdmin' || role === 'Developer') {
        this.showDelete = true
      }
    } else {
      this.isUpdate = false
      workOrderPromise = this.getEmptyWorkOrder(this.projectCode).then((workOrder) => {
        this.workOrder = workOrder
      })
    }

    let userPromise = this.getAllUsers().then((users) => {
      this.users = users
    })

    let pricePromise = this.getPrices(this.projectCode).then((prices) => {
      this.prices = prices
    })

    /*
    let deliveryPromise = this.getAllDeliveries().then((users) => {
      this.users = users
    })
    */

    Promise.all([workOrderPromise, userPromise, pricePromise]).then(() => {
      if (this.workOrder.workOrderHelperRequired) {
        this.workOrder.workOrderHelperUserId = -1
      }
      this.display = true

      if (this.status === 'Registered') {
        this.workOrder.status = 'Registered'
      }

      if (this.workOrder.items.length === 0) {
        this.addRateLine()
      }
    })
  }
}
</script>

<style lang="scss">
  .label-left {
    width: 100px;
    flex-shrink: 0;
  }
  .inline-input {
    flex-grow: 1
  }
  .line-wrapper {
    margin-bottom: 10px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EEE;
  }
  .minus-button {
    width: 36px;
    margin-right: 5px;
  }
  .plus-button {
    width: 36px;
    margin-left: 5px;
  }
  .mobile-box {
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/WorkOrderModal.vue